import React from 'react';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { Link } from '@/components/link/Link';
import { VariantComponentProps } from '../types';

const TextCTA: React.FC<VariantComponentProps<'text'>> = ({
  title,
  description,
  link,
}) => {
  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-neutral-0 px-6 py-8 shadow-sm md:flex-row md:items-start md:gap-10 md:px-10 md:py-10">
      {/* Left: title only */}
      <div className="flex w-full flex-none flex-col md:w-2/5">
        {title && (
          <Headline
            variant="headingFour"
            title={title}
            className="!m-0 text-brand-700"
          />
        )}
      </div>

      <div className="flex w-full flex-1 flex-col gap-4">
        {description?.content && (
          <SerializeDescription
            description={description.content}
            className="text-sm text-neutral-700"
          />
        )}

        {link && <Link {...link} className="w-full !rounded-full md:w-max" />}
      </div>
    </div>
  );
};

export default TextCTA;
